(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function () {
    var section = document.querySelector('[data-cart-section]');
    if (!section) return;

    var pending = false;

    function hideUpdateButton(root) {
      var btn = root.querySelector('.cart__update');
      if (btn) btn.style.display = 'none';
    }

    hideUpdateButton(section);

    function syncHeaderCount(cart) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count > 0 ? ' (' + cart.item_count + ')' : '';
      });
    }

    function clearBusy() {
      document.querySelectorAll('.is-busy').forEach(function (el) {
        el.classList.remove('is-busy');
      });
    }

    function changeLine(key, quantity, busyEl) {
      if (pending) return;
      var current = document.querySelector('[data-cart-section]');
      if (!current) return;
      var sectionId = current.dataset.sectionId;

      pending = true;
      if (busyEl) busyEl.classList.add('is-busy');

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          id: key,
          quantity: quantity,
          sections: [sectionId],
          sections_url: window.location.pathname
        })
      })
        .then(function (response) {
          if (!response.ok) throw new Error('change failed');
          return response.json();
        })
        .then(function (cart) {
          syncHeaderCount(cart);
          var html = cart.sections && cart.sections[sectionId];
          if (!html) throw new Error('no section html');
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-cart-section]');
          if (!fresh) throw new Error('no section root');
          current.replaceWith(fresh);
          hideUpdateButton(fresh);
          pending = false;
          clearBusy();
        })
        .catch(function () {
          pending = false;
          clearBusy();
          window.location.reload();
        });
    }

    function lineQuantity(item) {
      var input = item.querySelector('.cart__quantity-input');
      var quantity = parseInt(input && input.value, 10);
      if (isNaN(quantity) || quantity < 0) quantity = 0;
      return quantity;
    }

    document.addEventListener('change', function (event) {
      var input = event.target.closest('.cart__quantity-input');
      if (!input) return;
      var item = input.closest('[data-key]');
      if (!item) return;
      changeLine(item.dataset.key, lineQuantity(item), item);
    });

    document.addEventListener('click', function (event) {
      var step = event.target.closest('.cart__step');
      if (step) {
        var stepItem = step.closest('[data-key]');
        if (!stepItem || pending) return;
        var input = stepItem.querySelector('.cart__quantity-input');
        var next = (parseInt(input.value, 10) || 0) + Number(step.dataset.step);
        if (next < 0) next = 0;
        input.value = next;
        changeLine(stepItem.dataset.key, next, stepItem);
        return;
      }

      var link = event.target.closest('.cart__item-remove');
      if (!link) return;
      var item = link.closest('[data-key]');
      if (!item) return;
      event.preventDefault();
      changeLine(item.dataset.key, 0, item);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    var slider = document.querySelector('[data-object-slider]');
    var thumbs = document.querySelector('[data-object-thumbs]');
    if (!slider || !thumbs) return;

    var buttons = Array.prototype.slice.call(thumbs.querySelectorAll('.object__thumb'));

    function setActive(index) {
      buttons.forEach(function (btn) {
        btn.classList.toggle('is-active', Number(btn.dataset.index) === index);
      });
    }

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var index = Number(btn.dataset.index);
        var item = slider.children[index];
        if (!item) return;
        slider.scrollTo({ left: item.offsetLeft - slider.offsetLeft, behavior: 'smooth' });
        setActive(index);
      });
    });

    var ticking = false;
    slider.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var width = slider.clientWidth;
        if (width > 0) setActive(Math.round(slider.scrollLeft / width));
        ticking = false;
      });
    });
  })();

  (function () {
    var button = document.querySelector('[data-add-to-cart]');
    if (!button) return;
    var form = button.closest('form');
    if (!form) return;

    form.addEventListener('submit', function (event) {
      if (button.classList.contains('is-loading')) {
        event.preventDefault();
        return;
      }
      event.preventDefault();
      button.classList.add('is-loading');

      fetch(form.action + '.js', {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'application/json' }
      })
        .then(function (response) {
          if (!response.ok) throw new Error('add failed');
          return fetch('/cart.js', { headers: { Accept: 'application/json' } });
        })
        .then(function (response) {
          return response.json();
        })
        .then(function (cart) {
          document.querySelectorAll('[data-cart-count]').forEach(function (el) {
            el.textContent = cart.item_count > 0 ? ' (' + cart.item_count + ')' : '';
          });
          var original = button.textContent;
          button.classList.remove('is-loading');
          button.classList.add('is-added');
          button.textContent = button.dataset.addedLabel || original;
          setTimeout(function () {
            button.classList.remove('is-added');
            button.textContent = original;
          }, 2000);
        })
        .catch(function () {
          button.classList.remove('is-loading');
          form.submit();
        });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
